import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerWalletComponent } from 'src/app/componentsWallet/components/container-wallet/container-wallet.component';
import { PaymentsComponentClient } from 'src/app/componentsWallet/components/payments/payments.component';
import { IonicModule } from '@ionic/angular';
import { BalanceToolbarComponent } from 'src/app/componentsWallet/components/balance-toolbar/balance-toolbar.component';
import { ClientsComponent } from 'src/app/componentsWallet/components/clients/clients.component';
import { HistoryComponent } from 'src/app/componentsWallet/components/history/history.component';
import { BalanceToolbarPaymentsComponent } from 'src/app/componentsWallet/components/balance-toolbar-payments/balance-toolbar-payments.component';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { GiftCardPreviewComponent } from './gift-card-preview/gift-card-preview.component';
import { CashOutComponent } from 'src/app/componentsWallet/components/cash-out/cash-out.component';
import { FormsModule } from '@angular/forms';

const declarations = [
  ContainerWalletComponent,
  PaymentsComponentClient,
  BalanceToolbarComponent,
  ClientsComponent,
  HistoryComponent,
  BalanceToolbarPaymentsComponent,
  GiftCardPreviewComponent,
  CashOutComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    PipeModule,
    TranslateModule,
    FormsModule,
  ],
  exports: declarations,
})
export class ComponentsWalletModule {}
